export default '5.66.2';
